<div class="vh-100 d-flex w-100 proposals-overview" xmlns="http://www.w3.org/1999/html"
     *ngIf="{selectedProposal: (proposalSelected$|async), id:(proposalSelectedId$|async), selectedFilter:(filterSelected$|async)} as selectedProposal">
  <div class="d-flex flex-row  gap-3 flex-grow-1 justify-content-between position-relative w-100">

    <div class="d-flex flex-column overview-outer-container  h-100 py-4 "
         *ngIf="(
           !(loadingUser$|async) &&
              (
                ((this.selectedUser$|async).type == Roles.ROLE_BROKER) ||
                ((this.selectedUser$|async).type == Roles.ROLE_INSURER)||
                ((this.selectedUser$|async).type == Roles.ROLE_UNDERWRITER) ||
                ((this.selectedUser$|async).isBusinessAdmin === true) ||
                ((this.selectedUser$|async).representedUsers.length > 0)
              )
            )"
         [class.filter-hidden]="filterHidden">

      <div class="d-flex align-items-end justify-content-between header-container">
        <div class="d-flex flex-row w-fit-content align-items-end">
          <h4 class="text-nowrap align-self-start mb-0">
            {{ "proposalOverview"|translate}}
          </h4>
        </div>
        <div class="d-flex align-items-end justify-content-end" [formGroup]="formGroup">
          <button *ngIf="filterHidden" class="blue-border me-4 activate-filter-button" (click)="filterHidden = false">
            <img
              src="assets/svg-icons/configure-active.svg"
              alt="{{'nav.account' | translate}}" class="me-2"/>{{'showFilter'|translate}}</button>
          <div class="sorting-title pe-2">{{'sorting.title' | translate}}:</div>
          <div class="d-flex flex-row">
            <mat-select class="sortBy" formControlName="sortBy">
              <mat-option *ngFor="let sortParameter of ProposalTileSortParameter | keyvalue"
                          [value]="sortParameter.value">
                {{'sorting.' + sortParameter.value | translate}}</mat-option>
            </mat-select>
            <button class="btn shadow-none border-0 p-0 m-0 ms-2 d-flex align-items-center sort-direction-button"
                    (click)="changeSortDirection()">
              <img alt="" src="assets/svg-icons/arrow-chevron-down.svg" [class.ascending]="formGroup.value.ascending">
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row  filter-proposal-container justify-content-between ">
        <app-proposal-filter [(filterHidden)]="filterHidden" [class.d-none]="filterHidden"
                             [tilesNumber]="(this.proposalNumber$|async)"
                             class="flex-shrink-0 filter-bar"></app-proposal-filter>



          <ng-scrollbar visibility="hover" class="w-100 ps-show-always h-100 tiles pe-3 flex-shrink-1"
               #scrollProposalTiles>
            <div class="d-flex flex-column gap-3 mx-1">
              <ng-container *ngFor="let proposalTile of (this.proposalTiles$|async)">
                <app-proposal-tile *ngIf="!proposalTile.hideTile" [proposalTile]="proposalTile"
                                   [selected]="proposalTile.id === selectedProposal.id"
                                   [transparent]="proposalTile.id !== selectedProposal.id"
                                   [hideCreateOffer]="(selectedProposal.selectedFilter?.selectedRole === FilterRole.REJECTED_PROPOSALS) || ((this.activeUserId$|async) == proposalTile.userId)"
                                   (click)="selectProposalTile(proposalTile.id)"></app-proposal-tile>
              </ng-container>
            </div>
            <ng-container *ngIf="((!(loading$|async) && (allTilesLoaded$|async)) || errorOccurred);else loading">

              <ng-container *ngIf="(this.proposalTiles$|async).length === 0 && isDefaultFilter(selectedProposal.selectedFilter)">
                <div class="no-proposal">
                  <img class="icon" alt="{{'noProposal.Insurer.1' | translate}}" src="assets/svg-icons/blur-on.svg">
                  <h5 class="mt-5 text-nowrap text-center">
                    {{'noProposal.Insurer.1' | translate}}
                  </h5>
                  <h6 class="mt-3 text-center">
                    {{'noProposal.Insurer.2' | translate}} <br /> {{'noProposal.Insurer.3' | translate}} <br /> {{'noProposal.Insurer.4' | translate}}
                  </h6>
                </div>
              </ng-container>
              <ng-container *ngIf="(this.proposalTiles$|async).length === 0 && !isDefaultFilter(selectedProposal.selectedFilter)">
                <div class="no-proposal">
                  <img class="icon" alt="{{'noProposalWithFilters.1' | translate}}" src="assets/svg-icons/blur-on.svg">
                  <h5 class="mt-5 text-nowrap text-center">
                    {{'noProposalWithFilters.1' | translate}}
                  </h5>
                  <h6 class="mt-3 text-center">
                    {{'noProposalWithFilters.2' | translate}}
                  </h6>
                </div>
              </ng-container>

              <div class="w-100 d-flex justify-content-center back-to-top">
                <button *ngIf="(this.proposalTiles$|async).length > 6"
                        class="btn shadow-none border-0 p-0 m-0 d-flex align-items-center"
                        (click)="backToTop()">
                  <div class="d-flex flex-column align-items-center w-100">
                  <span class="mb-3">
                  {{'seenAllProposal' | translate}}
                </span>
                    <div class=" d-flex flex-column align-items-center w-100">
                      <mat-icon class="main-blue upwards-arrow mb-1">arrow_upward</mat-icon>
                      <span class="main-blue"> {{'backToTop'|translate}}</span>
                    </div>
                  </div>

                </button>
              </div>
            </ng-container>
          </ng-scrollbar>

      </div>
    </div>
    <div class="empty-space"></div>
    <div class="proposal-preview hide-on-small-screen" *ngIf="selectedProposal.id == null"></div>
    <div class="proposal-preview" *ngIf="selectedProposal.id != null">
      <app-proposal-preview class="w-100 h-100"></app-proposal-preview>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="w-100 d-flex justify-content-center mb-2">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>
